import { orgSchema, breadcrumbSchema } from '../lib/seo'
import SeoHead from '../components/SeoHead'
import ExpertisePage from '../components/expertise/ExpertisePage'
import AfscaShield from '../components/expertise/AfscaShield'
import AfscaAmbientGauge from '../components/expertise/AfscaAmbientGauge'
import AfscaFefo from '../components/expertise/AfscaFefo'
import { useExpertiseContent } from '../components/expertise/useExpertiseContent'
import { useT, useLocale } from '../i18n/LocaleContext'
import { localizedPath } from '../i18n/routes'

/**
 * Expertise — AFSCA (denrées alimentaires, stockage ambiant).
 * Page différenciante : Yaslan est enregistré AFSCA pour le stockage alimentaire
 * à température ambiante. Animations bespoke câblées en Task 4.
 */
export default function AfscaPage() {
  const { t } = useT()
  const locale = useLocale()
  const content = useExpertiseContent('afscaPage')
  const path = localizedPath('expertise.afsca', locale)
  const url = `https://yaslan.be${path}`

  return (
    <>
      <SeoHead
        title={t('seo.afsca.title')}
        description={t('seo.afsca.description')}
        path={path}
        jsonLd={[
          {
            '@type': 'Service',
            '@id': `${url}#service`,
            name: 'Stockage alimentaire AFSCA e-commerce — Yaslan',
            serviceType: 'Logistique alimentaire à température ambiante (AFSCA)',
            description: t('seo.afsca.description'),
            provider: { '@id': 'https://yaslan.be/#organization' },
            areaServed: ['Europe', 'United Kingdom', 'Switzerland'],
            url,
          },
          {
            '@type': 'FAQPage',
            '@id': `${url}#faq`,
            inLanguage: locale,
            mainEntity: content.faq.map((f) => ({
              '@type': 'Question',
              name: f.q,
              acceptedAnswer: { '@type': 'Answer', text: f.a },
            })),
          },
          orgSchema(locale),
          breadcrumbSchema([
            { name: t('breadcrumb.home'), path: localizedPath('home', locale) },
            { name: t('breadcrumb.afsca'), path },
          ]),
        ]}
      />
      <ExpertisePage
        content={content}
        breadcrumbLabel={t('breadcrumb.afsca')}
        heroVisual={
          <AfscaShield
            badge={content.anim.shield.badge}
            label={content.anim.shield.label}
          />
        }
        scopeVisual={
          <AfscaAmbientGauge
            badge={content.anim.gauge.badge}
            ambient={content.anim.gauge.ambient}
            chilled={content.anim.gauge.chilled}
            frozen={content.anim.gauge.frozen}
          />
        }
        processVisual={
          <AfscaFefo
            badge={content.anim.fefo.badge}
            title={content.anim.fefo.title}
            next={content.anim.fefo.next}
          />
        }
      />
    </>
  )
}
